var _path, _rect, _rect2, _g, _g2, _rect3, _path2, _g3, _path3, _mask, _path4, _path5, _rect4, _mask2, _path6, _path7, _g4, _mask3, _path8, _path9, _g5, _mask4, _path10, _path11, _g6, _mask5, _path12, _path13, _g7, _mask6, _path14, _path15, _g8, _mask7, _path16, _path17, _g9, _mask8, _path18, _path19, _g10, _mask9, _path20, _path21, _g11, _mask10, _path22, _path23, _g12, _path24, _g13, _mask11, _path25, _path26, _rect5, _mask12, _path27, _path28, _g14, _mask13, _path29, _path30, _g15, _mask14, _path31, _path32, _g16, _mask15, _path33, _path34, _g17, _mask16, _path35, _path36, _g18, _mask17, _path37, _path38, _g19, _mask18, _path39, _path40, _g20, _mask19, _path41, _path42, _g21, _mask20, _path43, _path44, _g22, _rect6, _g23, _mask21, _path45, _path46, _rect7, _mask22, _path47, _path48, _g24, _mask23, _path49, _path50, _g25, _mask24, _path51, _path52, _g26, _mask25, _path53, _path54, _g27, _mask26, _path55, _path56, _g28, _mask27, _path57, _path58, _g29, _mask28, _path59, _path60, _g30, _mask29, _path61, _path62, _g31, _mask30, _path63, _path64, _g32, _rect8, _g33, _mask31, _path65, _path66, _rect9, _mask32, _path67, _path68, _g34, _mask33, _path69, _path70, _g35, _mask34, _path71, _path72, _g36, _mask35, _path73, _path74, _g37, _mask36, _path75, _path76, _g38, _mask37, _path77, _path78, _g39, _mask38, _path79, _path80, _g40, _mask39, _path81, _path82, _g41, _mask40, _path83, _path84, _g42, _rect10, _g43, _mask41, _path85, _path86, _rect11, _mask42, _path87, _path88, _g44, _mask43, _path89, _path90, _g45, _mask44, _path91, _path92, _g46, _mask45, _path93, _path94, _g47, _mask46, _path95, _path96, _g48, _mask47, _path97, _path98, _g49, _mask48, _path99, _path100, _g50, _mask49, _path101, _path102, _g51, _mask50, _path103, _path104, _g52, _rect12, _g53, _mask51, _path105, _path106, _rect13, _mask52, _path107, _path108, _g54, _mask53, _path109, _path110, _g55, _mask54, _path111, _path112, _g56, _mask55, _path113, _path114, _g57, _mask56, _path115, _path116, _g58, _mask57, _path117, _path118, _g59, _mask58, _path119, _path120, _g60, _mask59, _path121, _path122, _g61, _mask60, _path123, _path124, _g62, _rect14, _g63, _mask61, _path125, _path126, _g64, _mask62, _path127, _path128, _g65, _mask63, _path129, _path130, _g66, _mask64, _path131, _path132, _g67, _mask65, _path133, _path134, _g68, _mask66, _path135, _path136, _g69, _mask67, _path137, _path138, _g70, _mask68, _path139, _path140, _g71, _mask69, _path141, _path142, _g72, _mask70, _path143, _path144, _g73, _rect15, _g74, _rect16, _g75, _mask71, _path145, _path146, _g76, _mask72, _path147, _path148, _g77, _mask73, _path149, _path150, _g78, _mask74, _path151, _path152, _g79, _mask75, _path153, _path154, _g80, _mask76, _path155, _path156, _g81, _mask77, _path157, _path158, _g82, _mask78, _path159, _path160, _g83, _rect17, _g84, _rect18, _g85, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedTableSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1288,
    height: 644,
    viewBox: "0 0 1288 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H1278C1283.52 0 1288 4.47715 1288 10V123H0V10Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22.3008,
    width: 1232,
    height: 14.4,
    rx: 4,
    fill: "#E4E4E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 61,
    width: 335.414,
    height: 44,
    rx: 6,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23251_19705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.522 82.693C62.5312 83.59 62.3637 84.4801 62.0289 85.3123C61.6941 86.1446 61.1986 86.9027 60.5708 87.5435C59.9429 88.1842 59.195 88.695 58.3698 89.0467C57.5445 89.3983 56.658 89.584 55.761 89.593C54.864 89.584 53.9775 89.3983 53.1522 89.0467C52.327 88.695 51.579 88.1842 50.9512 87.5435C50.3234 86.9027 49.8279 86.1446 49.4931 85.3123C49.1583 84.4801 48.9908 83.59 49 82.693C48.9908 81.7959 49.1583 80.9059 49.4931 80.0736C49.8279 79.2414 50.3234 78.4832 50.9512 77.8425C51.579 77.2017 52.327 76.6909 53.1522 76.3393C53.9775 75.9876 54.864 75.802 55.761 75.793C56.658 75.802 57.5445 75.9876 58.3698 76.3393C59.195 76.6909 59.9429 77.2017 60.5708 77.8425C61.1986 78.4832 61.6941 79.2414 62.0289 80.0736C62.3637 80.9059 62.5312 81.7959 62.522 82.693Z",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 89.7948L61.155 86.8828",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.4141,
    y: 77.3984,
    width: 192,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1068,
    y: 61,
    width: 196,
    height: 44,
    rx: 7,
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.73 90.7904L1083.73 84.7302M1083.73 84.7302C1084.69 84.7302 1085.46 83.955 1085.46 82.9987C1085.46 82.0424 1084.69 81.2672 1083.73 81.2672M1083.73 84.7302C1082.78 84.7302 1082 83.955 1082 82.9987C1082 82.0424 1082.78 81.2672 1083.73 81.2672M1089.79 90.7904V82.9987M1089.79 76.9385V75.207M1089.79 76.9385C1090.75 76.9385 1091.52 77.7137 1091.52 78.67C1091.52 79.6263 1090.75 80.4015 1089.79 80.4015C1088.84 80.4015 1088.06 79.6263 1088.06 78.67C1088.06 77.7137 1088.84 76.9385 1089.79 76.9385ZM1083.73 81.2672L1083.73 75.207M1095.85 82.9987V75.207M1095.85 90.7904V89.0589M1095.85 89.0589C1096.81 89.0589 1097.58 88.2837 1097.58 87.3274C1097.58 86.3711 1096.81 85.5959 1095.85 85.5959C1094.9 85.5959 1094.12 86.3711 1094.12 87.3274C1094.12 88.2837 1094.9 89.0589 1095.85 89.0589Z",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1107.33,
    y: 77.0664,
    width: 127.416,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.5 84.2141L1248.66 80.1691C1248.81 80.0255 1249.01 79.9453 1249.22 79.9453C1249.42 79.9453 1249.62 80.0255 1249.77 80.1691C1249.84 80.2395 1249.9 80.3236 1249.94 80.4165C1249.98 80.5094 1250 80.6093 1250 80.7101C1250 80.811 1249.98 80.9108 1249.94 81.0038C1249.9 81.0967 1249.84 81.1808 1249.77 81.2511L1245.06 85.8331C1244.91 85.9722 1244.72 86.0517 1244.52 86.0558C1244.32 86.0599 1244.13 85.9882 1243.97 85.8551L1239.23 81.2551C1239.16 81.1849 1239.1 81.1009 1239.06 81.0079C1239.02 80.915 1239 80.8151 1239 80.7141C1239 80.6132 1239.02 80.5133 1239.06 80.4204C1239.1 80.3274 1239.16 80.2433 1239.23 80.1731C1239.38 80.0295 1239.58 79.9493 1239.78 79.9493C1239.99 79.9493 1240.19 80.0295 1240.34 80.1731L1244.5 84.2141Z",
    fill: "#4B4B4B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 123H85V164H0V123Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 123H85V164H0V123Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 123H84V164H85H86V123H85Z",
    fill: "#E4E4E4",
    mask: "url(#path-11-inside-1_23251_19705)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 137.398,
    width: 44,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-2_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 164H85V212H0V164Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 164H85V212H0V164Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85 212V211H0V212V213H85V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-14-inside-2_23251_19705)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 183.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-3_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 212H85V260H0V212Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 212H85V260H0V212Z",
    fill: "#FBFBFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85 260V259H0V260V261H85V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-17-inside-3_23251_19705)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 231.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-4_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 260H85V308H0V260Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 260H85V308H0V260Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85 308V307H0V308V309H85V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-20-inside-4_23251_19705)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 279.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-5_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 308H85V356H0V308Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 308H85V356H0V308Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85 356V355H0V356V357H85V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-23-inside-5_23251_19705)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 327.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-6_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 356H85V404H0V356Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 356H85V404H0V356Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85 404V403H0V404V405H85V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-26-inside-6_23251_19705)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 375.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-7_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 404H85V452H0V404Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 404H85V452H0V404Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85 452V451H0V452V453H85V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-29-inside-7_23251_19705)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 423.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-8_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 452H85V500H0V452Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 452H85V500H0V452Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85 500V499H0V500V501H85V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-32-inside-8_23251_19705)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 471.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-9_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500H85V548H0V500Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 500H85V548H0V500Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85 548V547H0V548V549H85V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-35-inside-9_23251_19705)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 519.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-10_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 548H85V596H0V548Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 548H85V596H0V548Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85 596V595H0V596V597H85V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-38-inside-10_23251_19705)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 567.898,
    width: 46.3274,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 596H85V644H10C4.47715 644 0 639.523 0 634V596Z",
    fill: "white"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 615.898,
    width: 61.4107,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-11_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 123H388V164H85V123Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85 123H388V164H85V123Z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M388 123H387V164H388H389V123H388Z",
    fill: "#E4E4E4",
    mask: "url(#path-43-inside-11_23251_19705)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 137.398,
    width: 123,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-46-inside-12_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 164H388V212H85V164Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85 164H388V212H85V164Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M388 212V211H85V212V213H388V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-46-inside-12_23251_19705)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 183.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-13_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 212H388V260H85V212Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85 212H388V260H85V212Z",
    fill: "#FBFBFB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M388 260V259H85V260V261H388V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-49-inside-13_23251_19705)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 231.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-52-inside-14_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 260H388V308H85V260Z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85 260H388V308H85V260Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M388 308V307H85V308V309H388V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-52-inside-14_23251_19705)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 278.852,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-15_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 308H388V356H85V308Z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85 308H388V356H85V308Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M388 356V355H85V356V357H388V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-55-inside-15_23251_19705)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 327.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-16_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 356H388V404H85V356Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85 356H388V404H85V356Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M388 404V403H85V404V405H388V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-58-inside-16_23251_19705)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 375.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-61-inside-17_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 404H388V452H85V404Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85 404H388V452H85V404Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M388 452V451H85V452V453H388V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-61-inside-17_23251_19705)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 423.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-18_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 452H388V500H85V452Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M85 452H388V500H85V452Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M388 500V499H85V500V501H388V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-64-inside-18_23251_19705)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 471.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-67-inside-19_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 500H388V548H85V500Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M85 500H388V548H85V500Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M388 548V547H85V548V549H388V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-67-inside-19_23251_19705)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 519.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-70-inside-20_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 548H388V596H85V548Z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85 548H388V596H85V548Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M388 596V595H85V596V597H388V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-70-inside-20_23251_19705)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 567.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 303,
    height: 48,
    transform: "translate(85 596)",
    fill: "white"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 615.898,
    width: 296.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-74-inside-21_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 123H523V164H388V123Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M388 123H523V164H388V123Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M523 123H522V164H523H524V123H523Z",
    fill: "#E4E4E4",
    mask: "url(#path-74-inside-21_23251_19705)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 137.398,
    width: 45,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-22_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 164H523V212H388V164Z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M388 164H523V212H388V164Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M523 212V211H388V212V213H523V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-77-inside-22_23251_19705)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 182.852,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-23_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 212H523V260H388V212Z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M388 212H523V260H388V212Z",
    fill: "#FBFBFB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M523 260V259H388V260V261H523V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-80-inside-23_23251_19705)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 231.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-24_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 260H523V308H388V260Z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M388 260H523V308H388V260Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M523 308V307H388V308V309H523V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-83-inside-24_23251_19705)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 279.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-86-inside-25_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 308H523V356H388V308Z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M388 308H523V356H388V308Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M523 356V355H388V356V357H523V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-86-inside-25_23251_19705)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 327.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    id: "path-89-inside-26_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 356H523V404H388V356Z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M388 356H523V404H388V356Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M523 404V403H388V404V405H523V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-89-inside-26_23251_19705)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 375.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    id: "path-92-inside-27_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 404H523V452H388V404Z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M388 404H523V452H388V404Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M523 452V451H388V452V453H523V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-92-inside-27_23251_19705)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 423.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    id: "path-95-inside-28_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 452H523V500H388V452Z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M388 452H523V500H388V452Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M523 500V499H388V500V501H523V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-95-inside-28_23251_19705)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 471.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    id: "path-98-inside-29_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 500H523V548H388V500Z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M388 500H523V548H388V500Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M523 548V547H388V548V549H523V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-98-inside-29_23251_19705)"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 519.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask30 || (_mask30 = /*#__PURE__*/React.createElement("mask", {
    id: "path-101-inside-30_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388 548H523V596H388V548Z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M388 548H523V596H388V548Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M523 596V595H388V596V597H523V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-101-inside-30_23251_19705)"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 567.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 48,
    transform: "translate(388 596)",
    fill: "white"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 615.898,
    width: 115.28,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask31 || (_mask31 = /*#__PURE__*/React.createElement("mask", {
    id: "path-105-inside-31_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 123H671V164H523V123Z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M523 123H671V164H523V123Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M671 123H670V164H671H672V123H671Z",
    fill: "#E4E4E4",
    mask: "url(#path-105-inside-31_23251_19705)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 137.398,
    width: 114,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _mask32 || (_mask32 = /*#__PURE__*/React.createElement("mask", {
    id: "path-108-inside-32_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 164H671V212H523V164Z"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M523 164H671V212H523V164Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M671 212V211H523V212V213H671V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-108-inside-32_23251_19705)"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 182.852,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask33 || (_mask33 = /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-33_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 212H671V260H523V212Z"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M523 212H671V260H523V212Z",
    fill: "#FBFBFB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M671 260V259H523V260V261H671V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-111-inside-33_23251_19705)"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 231.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask34 || (_mask34 = /*#__PURE__*/React.createElement("mask", {
    id: "path-114-inside-34_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 260H671V308H523V260Z"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M523 260H671V308H523V260Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M671 308V307H523V308V309H671V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-114-inside-34_23251_19705)"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 279.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask35 || (_mask35 = /*#__PURE__*/React.createElement("mask", {
    id: "path-117-inside-35_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 308H671V356H523V308Z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M523 308H671V356H523V308Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M671 356V355H523V356V357H671V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-117-inside-35_23251_19705)"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 327.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask36 || (_mask36 = /*#__PURE__*/React.createElement("mask", {
    id: "path-120-inside-36_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 356H671V404H523V356Z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M523 356H671V404H523V356Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M671 404V403H523V404V405H671V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-120-inside-36_23251_19705)"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 375.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask37 || (_mask37 = /*#__PURE__*/React.createElement("mask", {
    id: "path-123-inside-37_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 404H671V452H523V404Z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M523 404H671V452H523V404Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M671 452V451H523V452V453H671V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-123-inside-37_23251_19705)"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 423.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask38 || (_mask38 = /*#__PURE__*/React.createElement("mask", {
    id: "path-126-inside-38_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 452H671V500H523V452Z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M523 452H671V500H523V452Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M671 500V499H523V500V501H671V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-126-inside-38_23251_19705)"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 471.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask39 || (_mask39 = /*#__PURE__*/React.createElement("mask", {
    id: "path-129-inside-39_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 500H671V548H523V500Z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M523 500H671V548H523V500Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M671 548V547H523V548V549H671V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-129-inside-39_23251_19705)"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 519.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask40 || (_mask40 = /*#__PURE__*/React.createElement("mask", {
    id: "path-132-inside-40_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523 548H671V596H523V548Z"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M523 548H671V596H523V548Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M671 596V595H523V596V597H671V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-132-inside-40_23251_19705)"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 567.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 48,
    transform: "translate(523 596)",
    fill: "white"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 615.898,
    width: 129.286,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask41 || (_mask41 = /*#__PURE__*/React.createElement("mask", {
    id: "path-136-inside-41_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 123H824V164H671V123Z"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M671 123H824V164H671V123Z",
    fill: "#F0F0F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M824 123H823V164H824H825V123H824Z",
    fill: "#E4E4E4",
    mask: "url(#path-136-inside-41_23251_19705)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 137.398,
    width: 86,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _mask42 || (_mask42 = /*#__PURE__*/React.createElement("mask", {
    id: "path-139-inside-42_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 164H824V212H671V164Z"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M671 164H824V212H671V164Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M824 212V211H671V212V213H824V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-139-inside-42_23251_19705)"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 183.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask43 || (_mask43 = /*#__PURE__*/React.createElement("mask", {
    id: "path-142-inside-43_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 212H824V260H671V212Z"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M671 212H824V260H671V212Z",
    fill: "#FBFBFB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M824 260V259H671V260V261H824V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-142-inside-43_23251_19705)"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 231.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask44 || (_mask44 = /*#__PURE__*/React.createElement("mask", {
    id: "path-145-inside-44_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 260H824V308H671V260Z"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M671 260H824V308H671V260Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M824 308V307H671V308V309H824V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-145-inside-44_23251_19705)"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 279.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask45 || (_mask45 = /*#__PURE__*/React.createElement("mask", {
    id: "path-148-inside-45_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 308H824V356H671V308Z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M671 308H824V356H671V308Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M824 356V355H671V356V357H824V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-148-inside-45_23251_19705)"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 327.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask46 || (_mask46 = /*#__PURE__*/React.createElement("mask", {
    id: "path-151-inside-46_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 356H824V404H671V356Z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M671 356H824V404H671V356Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M824 404V403H671V404V405H824V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-151-inside-46_23251_19705)"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 375.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask47 || (_mask47 = /*#__PURE__*/React.createElement("mask", {
    id: "path-154-inside-47_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 404H824V452H671V404Z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M671 404H824V452H671V404Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M824 452V451H671V452V453H824V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-154-inside-47_23251_19705)"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 423.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask48 || (_mask48 = /*#__PURE__*/React.createElement("mask", {
    id: "path-157-inside-48_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 452H824V500H671V452Z"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M671 452H824V500H671V452Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M824 500V499H671V500V501H824V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-157-inside-48_23251_19705)"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 471.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask49 || (_mask49 = /*#__PURE__*/React.createElement("mask", {
    id: "path-160-inside-49_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 500H824V548H671V500Z"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M671 500H824V548H671V500Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M824 548V547H671V548V549H824V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-160-inside-49_23251_19705)"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 519.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask50 || (_mask50 = /*#__PURE__*/React.createElement("mask", {
    id: "path-163-inside-50_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671 548H824V596H671V548Z"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M671 548H824V596H671V548Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M824 596V595H671V596V597H824V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-163-inside-50_23251_19705)"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 567.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 48,
    transform: "translate(671 596)",
    fill: "white"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 615.898,
    width: 134.673,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask51 || (_mask51 = /*#__PURE__*/React.createElement("mask", {
    id: "path-167-inside-51_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 123H977.5V164H824V123Z"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M824 123H977.5V164H824V123Z",
    fill: "#F0F0F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 123H976.5V164H977.5H978.5V123H977.5Z",
    fill: "#E4E4E4",
    mask: "url(#path-167-inside-51_23251_19705)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 137.398,
    width: 121,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _mask52 || (_mask52 = /*#__PURE__*/React.createElement("mask", {
    id: "path-170-inside-52_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 164H977.5V212H824V164Z"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M824 164H977.5V212H824V164Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 212V211H824V212V213H977.5V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-170-inside-52_23251_19705)"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 182.852,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask53 || (_mask53 = /*#__PURE__*/React.createElement("mask", {
    id: "path-173-inside-53_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 212H977.5V260H824V212Z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M824 212H977.5V260H824V212Z",
    fill: "#FBFBFB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 260V259H824V260V261H977.5V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-173-inside-53_23251_19705)"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 231.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask54 || (_mask54 = /*#__PURE__*/React.createElement("mask", {
    id: "path-176-inside-54_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 260H977.5V308H824V260Z"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M824 260H977.5V308H824V260Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 308V307H824V308V309H977.5V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-176-inside-54_23251_19705)"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 279.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask55 || (_mask55 = /*#__PURE__*/React.createElement("mask", {
    id: "path-179-inside-55_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 308H977.5V356H824V308Z"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M824 308H977.5V356H824V308Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 356V355H824V356V357H977.5V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-179-inside-55_23251_19705)"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 327.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask56 || (_mask56 = /*#__PURE__*/React.createElement("mask", {
    id: "path-182-inside-56_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 356H977.5V404H824V356Z"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M824 356H977.5V404H824V356Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 404V403H824V404V405H977.5V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-182-inside-56_23251_19705)"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 375.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask57 || (_mask57 = /*#__PURE__*/React.createElement("mask", {
    id: "path-185-inside-57_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 404H977.5V452H824V404Z"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M824 404H977.5V452H824V404Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 452V451H824V452V453H977.5V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-185-inside-57_23251_19705)"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 423.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask58 || (_mask58 = /*#__PURE__*/React.createElement("mask", {
    id: "path-188-inside-58_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 452H977.5V500H824V452Z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M824 452H977.5V500H824V452Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 500V499H824V500V501H977.5V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-188-inside-58_23251_19705)"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 471.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask59 || (_mask59 = /*#__PURE__*/React.createElement("mask", {
    id: "path-191-inside-59_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 500H977.5V548H824V500Z"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M824 500H977.5V548H824V500Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 548V547H824V548V549H977.5V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-191-inside-59_23251_19705)"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 519.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask60 || (_mask60 = /*#__PURE__*/React.createElement("mask", {
    id: "path-194-inside-60_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M824 548H977.5V596H824V548Z"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M824 548H977.5V596H824V548Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 596V595H824V596V597H977.5V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-194-inside-60_23251_19705)"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 567.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 153.5,
    height: 48,
    transform: "translate(824 596)",
    fill: "white"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 842,
    y: 615.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask61 || (_mask61 = /*#__PURE__*/React.createElement("mask", {
    id: "path-198-inside-61_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 123H1134.5V164H977.5V123Z"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 123H1134.5V164H977.5V123Z",
    fill: "#F0F0F0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 123H1133.5V164H1134.5H1135.5V123H1134.5Z",
    fill: "#E4E4E4",
    mask: "url(#path-198-inside-61_23251_19705)"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 137.398,
    width: 99,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask62 || (_mask62 = /*#__PURE__*/React.createElement("mask", {
    id: "path-201-inside-62_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 164H1134.5V212H977.5V164Z"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 164H1134.5V212H977.5V164Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 212V211H977.5V212V213H1134.5V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-201-inside-62_23251_19705)"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 182.852,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask63 || (_mask63 = /*#__PURE__*/React.createElement("mask", {
    id: "path-204-inside-63_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 212H1134.5V260H977.5V212Z"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 212H1134.5V260H977.5V212Z",
    fill: "#FBFBFB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 260V259H977.5V260V261H1134.5V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-204-inside-63_23251_19705)"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 230.852,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask64 || (_mask64 = /*#__PURE__*/React.createElement("mask", {
    id: "path-207-inside-64_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 260H1134.5V308H977.5V260Z"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 260H1134.5V308H977.5V260Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 308V307H977.5V308V309H1134.5V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-207-inside-64_23251_19705)"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 279.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask65 || (_mask65 = /*#__PURE__*/React.createElement("mask", {
    id: "path-210-inside-65_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 308H1134.5V356H977.5V308Z"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 308H1134.5V356H977.5V308Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 356V355H977.5V356V357H1134.5V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-210-inside-65_23251_19705)"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 327.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask66 || (_mask66 = /*#__PURE__*/React.createElement("mask", {
    id: "path-213-inside-66_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 356H1134.5V404H977.5V356Z"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 356H1134.5V404H977.5V356Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 404V403H977.5V404V405H1134.5V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-213-inside-66_23251_19705)"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 375.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask67 || (_mask67 = /*#__PURE__*/React.createElement("mask", {
    id: "path-216-inside-67_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 404H1134.5V452H977.5V404Z"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 404H1134.5V452H977.5V404Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 452V451H977.5V452V453H1134.5V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-216-inside-67_23251_19705)"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 423.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask68 || (_mask68 = /*#__PURE__*/React.createElement("mask", {
    id: "path-219-inside-68_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 452H1134.5V500H977.5V452Z"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 452H1134.5V500H977.5V452Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 500V499H977.5V500V501H1134.5V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-219-inside-68_23251_19705)"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 471.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask69 || (_mask69 = /*#__PURE__*/React.createElement("mask", {
    id: "path-222-inside-69_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 500H1134.5V548H977.5V500Z"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 500H1134.5V548H977.5V500Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 548V547H977.5V548V549H1134.5V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-222-inside-69_23251_19705)"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 519.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask70 || (_mask70 = /*#__PURE__*/React.createElement("mask", {
    id: "path-225-inside-70_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.5 548H1134.5V596H977.5V548Z"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M977.5 548H1134.5V596H977.5V548Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 596V595H977.5V596V597H1134.5V596Z",
    fill: "#E4E4E4",
    mask: "url(#path-225-inside-70_23251_19705)"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 567.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 48,
    transform: "translate(977.5 596)",
    fill: "white"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 995.5,
    y: 615.898,
    width: 138.982,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 153.5,
    height: 41,
    transform: "translate(1134.5 123)",
    fill: "#F0F0F0"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip74_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 137.398,
    width: 101,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask71 || (_mask71 = /*#__PURE__*/React.createElement("mask", {
    id: "path-230-inside-71_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 164H1288V212H1134.5V164Z"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 164H1288V212H1134.5V164Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 212V211H1134.5V212V213H1288V212Z",
    fill: "#E4E4E4",
    mask: "url(#path-230-inside-71_23251_19705)"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 182.852,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask72 || (_mask72 = /*#__PURE__*/React.createElement("mask", {
    id: "path-233-inside-72_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 212H1288V260H1134.5V212Z"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 212H1288V260H1134.5V212Z",
    fill: "#FBFBFB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 260V259H1134.5V260V261H1288V260Z",
    fill: "#E4E4E4",
    mask: "url(#path-233-inside-72_23251_19705)"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip76_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 231.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask73 || (_mask73 = /*#__PURE__*/React.createElement("mask", {
    id: "path-236-inside-73_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 260H1288V308H1134.5V260Z"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 260H1288V308H1134.5V260Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 308V307H1134.5V308V309H1288V308Z",
    fill: "#E4E4E4",
    mask: "url(#path-236-inside-73_23251_19705)"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 279.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask74 || (_mask74 = /*#__PURE__*/React.createElement("mask", {
    id: "path-239-inside-74_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 308H1288V356H1134.5V308Z"
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 308H1288V356H1134.5V308Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 356V355H1134.5V356V357H1288V356Z",
    fill: "#E4E4E4",
    mask: "url(#path-239-inside-74_23251_19705)"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip78_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 327.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask75 || (_mask75 = /*#__PURE__*/React.createElement("mask", {
    id: "path-242-inside-75_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 356H1288V404H1134.5V356Z"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 356H1288V404H1134.5V356Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 404V403H1134.5V404V405H1288V404Z",
    fill: "#E4E4E4",
    mask: "url(#path-242-inside-75_23251_19705)"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 375.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask76 || (_mask76 = /*#__PURE__*/React.createElement("mask", {
    id: "path-245-inside-76_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 404H1288V452H1134.5V404Z"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 404H1288V452H1134.5V404Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 452V451H1134.5V452V453H1288V452Z",
    fill: "#E4E4E4",
    mask: "url(#path-245-inside-76_23251_19705)"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip80_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 423.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask77 || (_mask77 = /*#__PURE__*/React.createElement("mask", {
    id: "path-248-inside-77_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 452H1288V500H1134.5V452Z"
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 452H1288V500H1134.5V452Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 500V499H1134.5V500V501H1288V500Z",
    fill: "#E4E4E4",
    mask: "url(#path-248-inside-77_23251_19705)"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip81_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 471.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _mask78 || (_mask78 = /*#__PURE__*/React.createElement("mask", {
    id: "path-251-inside-78_23251_19705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 500H1288V548H1134.5V500Z"
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 500H1288V548H1134.5V500Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1288 548V547H1134.5V548V549H1288V548Z",
    fill: "#E4E4E4",
    mask: "url(#path-251-inside-78_23251_19705)"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip82_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 519.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 153.5,
    height: 48,
    transform: "translate(1134.5 548)",
    fill: "white"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip83_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 567.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 153.5,
    height: 48,
    transform: "translate(1134.5 596)",
    fill: "white"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip84_23251_19705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1152.5,
    y: 615.898,
    width: 135.211,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.414,
    height: 16.414,
    fill: "white",
    transform: "translate(48 74.793)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 15,
    fill: "white",
    transform: "translate(75.4141 75.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.416,
    height: 13.3333,
    fill: "white",
    transform: "translate(1107.33 76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3274,
    height: 21,
    fill: "white",
    transform: "translate(32 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.4107,
    height: 21,
    fill: "white",
    transform: "translate(18 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 18.9,
    fill: "white",
    transform: "translate(103 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296.28,
    height: 21,
    fill: "white",
    transform: "translate(103 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 18.9,
    fill: "white",
    transform: "translate(406 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.28,
    height: 21,
    fill: "white",
    transform: "translate(406 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 18.9,
    fill: "white",
    transform: "translate(541 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.286,
    height: 21,
    fill: "white",
    transform: "translate(541 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.673,
    height: 21,
    fill: "white",
    transform: "translate(689 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 18.9,
    fill: "white",
    transform: "translate(842 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(842 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 18,
    fill: "white",
    transform: "translate(995.5 134)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 18.9,
    fill: "white",
    transform: "translate(995.5 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 18.9,
    fill: "white",
    transform: "translate(995.5 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.982,
    height: 21,
    fill: "white",
    transform: "translate(995.5 611)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 18,
    fill: "white",
    transform: "translate(1152.5 134)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 18.9,
    fill: "white",
    transform: "translate(1152.5 179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 371)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 419)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 515)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 563)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84_23251_19705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.211,
    height: 21,
    fill: "white",
    transform: "translate(1152.5 611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedTableSection);
export default __webpack_public_path__ + "static/media/locked_table_section.eddd1f96aa3d613dddc87845324634cc.svg";
export { ForwardRef as ReactComponent };